import React, {useState} from 'react';
import { useDispatch } from 'react-redux'
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { createGroupUser, getGroupUsers } from '../../../services/api';
import { useSnackbar } from 'notistack';
import { setGroupUsers } from '../../../store/dataFromBESlice';
import { Button, TextField } from '@mui/material';


const CreateUserGroup = () => {
    const [t] = useTranslation()
    const dispatch = useDispatch()
    const history = useHistory()
    const [name,setName] = useState('')
    const [description,setDescription] = useState('')
    const {enqueueSnackbar} = useSnackbar()
    const handleName = (e) => {
      setName(e.target.value)
    }
    
    const handleDescription = (e) => {
      setDescription(e.target.value)
    }
    const handleCreate = () => {
        createGroupUser({
            name: name,
            description: description
        })
        .then(res => {
            enqueueSnackbar(res.message, {variant: res.code === 200 ? 'success' : ''})
            if (res.code === 200) {
                history.push('/usergroup')
                getGroupUsers().then(res => dispatch(setGroupUsers(res.data)))
            }
        })
    }
    return (
        <div>
            <h1 align='center'>{t('Thêm mới nhóm người dùng')}</h1>
            <TextField
                id="name-basic"
                label={t('Tên nhóm')}
                alignItems='left'
                onChange={handleName}
                value={name}
                fullWidth
                style={{margin: 10}}
            />
            <TextField
                id="description-basic"
                label={t('Mô tả')}
                onChange={handleDescription}
                multiline
                value={description}
                fullWidth
                style={{margin: 10}}
            />
            <Button color='secondary' variant='contained' style={{margin: 5}} onClick={() => history.push('/usergroup')}>{t('Quay lại')}</Button>
            <Button variant='contained' style={{margin: 5}} onClick={handleCreate}>{t('Tạo mới')}</Button>
        </div>
    );
}

export default CreateUserGroup